// eslint-disable-next-line
import { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const [navActive, setNavActive] = useState(false);
  const navigate = useNavigate();
  const NAVBAR_HEIGHT = 70; // used for scroll offset

  const toggleNav = () => setNavActive((prev) => !prev);
  const closeMenu = () => setNavActive(false);

  // Close menu when window resizes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) setNavActive(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="navbar__logo" onClick={() => navigate("/")}>
        <img src="/img/AB4S_logo.png" alt="AB4S logo" />
      </div>

      {/* Hamburger Button */}
      <button
        className={`navbar__hamburger ${navActive ? "navbar__hamburger--active" : ""}`}
        onClick={toggleNav}
        aria-label="Toggle navigation menu"
        aria-expanded={navActive}
      >
        <span className="navbar__hamburger-line"></span>
        <span className="navbar__hamburger-line"></span>
        <span className="navbar__hamburger-line"></span>
      </button>

      {/* Menu */}
      <div className={`navbar__menu ${navActive ? "navbar__menu--active" : ""}`}>
        <ul className="navbar__list">
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar__link--active"
              spy
              smooth
              offset={-NAVBAR_HEIGHT}
              duration={500}
              to="AboutMe"
              className="navbar__link"
            >
              About Us
            </Link>
          </li>

          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar__link--active"
              spy
              smooth
              offset={-NAVBAR_HEIGHT}
              duration={500}
              to="Mission"
              className="navbar__link"
            >
              Mission &amp; Vision
            </Link>
          </li>

          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar__link--active"
              spy
              smooth
              offset={-NAVBAR_HEIGHT}
              duration={500}
              to="mySkills"
              className="navbar__link"
            >
              Skills &amp; Experience
            </Link>
          </li>

          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar__link--active"
              spy
              smooth
              offset={-NAVBAR_HEIGHT}
              duration={500}
              to="MyPortfolio"
              className="navbar__link"
            >
              Our Team
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar__link--active"
              spy
              smooth
              offset={-NAVBAR_HEIGHT}
              duration={500}
              to="Testimonials"
              className="navbar__link"
            >
              Testimonials
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar__link--active"
              spy
              smooth
              offset={-NAVBAR_HEIGHT}
              duration={500}
              to="Contact"
              className="navbar__link"
            >
              Contact
            </Link>
          </li>
          {/* Desktop login (still btn-outline-primary) */}
          <li>
            <button
              className="btn-outline-primary desktop-login"
              onClick={() => {
                //closeMenu();
                navigate("/Signin");
              }}
            >
              Login
            </button>
          </li>
          {/* Mobile login inside menu */}
        <li>
          <button 
            className="mobile-login-btn"
            onClick={() => {
              closeMenu();
              navigate("/Signin");
            }}
          >
            Login
          </button>
        </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
